module.exports = __webpack_public_path__ + "img/statistical-analysis.d5a8acf9.svg";